/**
 * Recently-played games query hook (lobby row).
 *
 * Keyed by userId so the row is per-player and dedupes against any other
 * surface that reads the same list. Disabled when logged out (no user) - the
 * row is only rendered for logged-in players anyway.
 */

import { useQuery } from "@tanstack/react-query";
import profileService from "../../../shared/services/profileService";
import { queryKeys } from "../../../shared/data/queryKeys";
import { normalizeQueryError } from "../../../shared/data/errors";

/**
 * @param {string|undefined} userId - logged-in player id (gates the query)
 * @param {number} [limit]
 */
export function useRecentlyPlayed(userId, limit = 5) {
  return useQuery({
    queryKey: queryKeys.games.recentlyPlayed(userId),
    enabled: Boolean(userId),
    queryFn: async () => {
      try {
        const result = await profileService.getRecentlyPlayedGames(limit);
        // Handle both wrapped and unwrapped response formats.
        return result.data?.recently_played || result.recently_played || [];
      } catch (err) {
        throw normalizeQueryError(err, "Failed to load recently played games");
      }
    },
  });
}

export default useRecentlyPlayed;
